import { createAction, props } from "@ngrx/store";
import { ObterConteudoCadernoIdInputDto } from "src/app/domain/DTOs/input/jornal/obter-conteudo-caderno-id.input.dto";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";

const actionName = "[ ObterConteudoCadernoPorId ] Obter Conteudo Caderno Por Id";

export const obterConteudoCadernoPorId = createAction(
  actionName,
  props<{ inputDto: ObterConteudoCadernoIdInputDto}>()
);

export const obterConteudoCadernoPorIdSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<string> }>()
);

export const obterConteudoCadernoPorIdFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<string> }>()
);

export const obterConteudoCadernoPorIdFinish = createAction(
  `${actionName} - Concluir`
);